import { BaseService } from "./BaseService";

export interface IKnowledgeCategoryModel {
    uuid: string;
    name: string;
    /** Optional PrimeIcons class (`pi pi-bell`). Empty = folder icon in the UI. */
    icon?: string;
    displayOrder?: number;
    active?: boolean;
    /** Customer this category belongs to. The article editor only offers categories of the article's customer. */
    customerUuid?: string;
    /** False for a category of a customer above the viewer: visible (it holds an article shared down to them)
     *  but not theirs to rename or delete. */
    manageable?: boolean;
    /** Articles in this category the current user can reach. Comes with the list, no second call. */
    articleCount?: number;
}

export interface IKnowledgeCategoryCrudModel {
    name: string;
    icon?: string;
    displayOrder?: number;
    active?: boolean;
    /** Blank = the caller's own customer. The article editor sends the article's customer. */
    customerUuid?: string;
}

export class KnowledgeCategoryService extends BaseService<IKnowledgeCategoryModel, IKnowledgeCategoryCrudModel> {
    protected modelUrl(): string {
        return "knowledge-category";
    }
}
